


"use client"

import { Component } from "react"
import moment from "moment"
import API, { URL_PATH } from "../../services/API"
import redux from "../../common/Redux"
import routes from "../../routes/URL"
import Header from "../../components/Header"
import {
  Container,
  Paper,
  TextField,
  Button,
  Select,
  MenuItem,
  Box,
  Typography,
  Grid,
} from "@mui/material"
import Toast from "../../components/Toast"

class MainScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      coupon_code: "",
      coupon_type: "one_time",
      coupon_discount_type: "percentage",
      coupon_discount_value: "",
      coupon_description: "",
      coupon_min_order_amount: "",
      coupon_max_discount_amount: "",
      coupon_start_date: moment().format("YYYY-MM-DD"),
      coupon_end_date: moment().add(1, 'month').format("YYYY-MM-DD"),
      toast: {
        show: false,
        message: "",
        type: "success",
      },
    }
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  };
  saveData = async (e) => {
    e.preventDefault()
    
    if (!this.props.selectedHotelId?.id) {
      this.showToast("Hotel ID is required", "error")
     
      return
    }

    const requestBody = {
      hotel_id: this.props.selectedHotelId.id,
      coupon_code: this.state.coupon_code,
      coupon_type: this.state.coupon_type,
      coupon_discount_value: Number(this.state.coupon_discount_value),
      coupon_discount_type: this.state.coupon_discount_type,
      coupon_description: this.state.coupon_description,
      coupon_min_order_amount: this.state.coupon_min_order_amount,
      coupon_max_discount_amount: this.state.coupon_max_discount_amount,
      coupon_start_date: this.state.coupon_start_date,
      coupon_end_date: this.state.coupon_end_date,
      coupon_status: 1,
      value_for_coupon_type: 1
    }

    try {
      const data = await API(this, "post", URL_PATH.addCoupon, requestBody)
      if (data.status !== "success") {
        return this.showToast(data.message, "error")
        
       
      }
      
      this.setState({
        coupon_code: "",
        coupon_type: "one_time",
        coupon_discount_type: "percentage",
        coupon_discount_value: "",
        coupon_description: "",
        coupon_min_order_amount: "",
        coupon_max_discount_amount: "",
        coupon_start_date: moment().format("YYYY-MM-DD"),
        coupon_end_date: moment().add(1, 'month').format("YYYY-MM-DD")
      })
      this.showToast("Coupon created successfully", "success")
      this.props.history.push(routes.admin.coupon.root(this.props.hotels[0]?.hotel_slug || ''));
      
    } catch (error) {
      console.error("Error creating coupon:", error)
      this.showToast("Failed to create coupon", "error")
     
    }
  }

    componentDidMount() {
       const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
    if (!hotel) {
        this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
        return;
    }
  }

  render() {
    const {
      coupon_code,
      coupon_type,
      coupon_discount_type,
      coupon_discount_value,
      coupon_description,
      coupon_min_order_amount,
      coupon_max_discount_amount,
      coupon_start_date,
      coupon_end_date
    } = this.state

    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 3, borderRadius: 2 ,backgroundColor:"#02111B",backgroundImage:"none",   border: '1px solid #FFC857'}}>
<Header title="New Coupon" />
          
          <form onSubmit={this.saveData}>
            <Box display="flex" flexDirection="column" gap={3}>
              <TextField
                label="Coupon Code"
                variant="outlined"
                fullWidth
                value={coupon_code}
                onChange={(e) => this.setState({ coupon_code: e.target.value })}
                required
              />
              
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Select
                    value={coupon_type}
                    fullWidth
                    onChange={(e) => this.setState({ coupon_type: e.target.value })}
                  >
                    <MenuItem value="one_time">One Time</MenuItem>
                    <MenuItem value="multiple_time">Multiple Time</MenuItem>
                    <MenuItem value="first_time">First Time</MenuItem>
                    <MenuItem value="once_a_month">Once a Month</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={6}>
                  <Select
                    value={coupon_discount_type}
                    fullWidth
                    onChange={(e) => this.setState({ coupon_discount_type: e.target.value })}
                  >
                    <MenuItem value="percentage">Percentage</MenuItem>
                    <MenuItem value="fixed">Fixed</MenuItem>
                  </Select>
                </Grid>
              </Grid>

              <TextField
                label="Discount Value"
                variant="outlined"
                fullWidth
                value={coupon_discount_value}
                onChange={(e) => this.setState({ coupon_discount_value: e.target.value })}
                required
              />
              
              <TextField
                label="Coupon Description"
                variant="outlined"
                fullWidth
                multiline
                rows={3}
                value={coupon_description}
                onChange={(e) => this.setState({ coupon_description: e.target.value })}
                required
              />
              
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    label="Minimum Order Amount"
                    variant="outlined"
                    fullWidth
                    value={coupon_min_order_amount}
                    onChange={(e) => this.setState({ coupon_min_order_amount: e.target.value })}
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="Maximum Discount Amount"
                    variant="outlined"
                    fullWidth
                    value={coupon_max_discount_amount}
                    onChange={(e) => this.setState({ coupon_max_discount_amount: e.target.value })}
                    required
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={6}>
                <style>
                  {`
          input[type="date"]::-webkit-calendar-picker-indicator {
            filter: invert(1);
            margin-left: 8px; /* Add margin to the left of the icon */
          }
          input[type="date"] {
            padding-right: 8px; /* Add padding to the right of the input */
          }
        `}
                </style>
                  <TextField
                    label="Start Date"
                    type="date"
                    variant="outlined"
                    fullWidth
                    value={coupon_start_date}
                    onChange={(e) => this.setState({ coupon_start_date: e.target.value })}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    label="End Date"
                    type="date"
                    variant="outlined"
                    fullWidth
                    value={coupon_end_date}
                    onChange={(e) => this.setState({ coupon_end_date: e.target.value })}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                </Grid>
              </Grid>

              <Button 
                type="submit" 
                variant="contained" 
              
                
                sx={{ mt: 2 ,backgroundColor: "#FFC857", color: "black",fontWeight:"700" ,alignSelf:"flex-start",'&:hover': { backgroundColor: "#FFC857", color: "black" } }}
              >
                Submit
              </Button>
            </Box>
          </form>
        </Paper>
        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        onClose={this.handleCloseToast}
      />
      </Container>
    )
  }
}

export default redux(MainScreen)